module.exports = __webpack_public_path__ + "img/maintop.112a818.png";